angular.module('app').directive('footerDir', function(){
    return{
        restrict: 'AE',
        templateUrl: './views/directives/footerDir.html'
    }
})